const Monitor = () => {
	return (
		<div>
			<h1>Expense is running</h1>
		</div>
	);
}

export default Monitor;
